export default class Dropdown {
	constructor(element) {
		this.element = element;
		this.options = {
			open: false,
			horizontal: false,
			hover: false,
		};

		this.init();
	}
	setOptions() {
		if ("open" in this.element.dataset) {
			this.options.open = true;
		}
		if ("horizontal" in this.element.dataset) {
			this.options.horizontal = true;
		}
		if ("hover" in this.element.dataset) {
			this.options.hover = true;
		}
	}

	init() { this.setOptions();

    const containers = this.element.querySelectorAll(".faq-item");
    if (this.options.hover) {
        containers.forEach((el) => {
            el.addEventListener("mouseenter", this.openDropdown.bind(this));
            el.addEventListener("mouseleave", this.closeDropdown.bind(this));
        });
    }
		containers.forEach((el) =>
			el.addEventListener("click", this.toggleDropdown.bind(this)),
		);
		document.addEventListener("DOMContentLoaded", () => {
			this.lockHorizontalHeight();
			this.openFirstCard();
		});
				window.addEventListener("resize", this.lockHorizontalHeight.bind(this));

	}
	openFirstCard() {
		if (this.options.open) {
			const containers = this.element.querySelectorAll(".faq-item");
			if (this.options.horizontal) {
				requestAnimationFrame(() => {
					this.toggleHorizontal(containers[0]);
				});
			} else {
				containers[0].classList.add("submenu-is-active");
				const content =
					containers[0].querySelector(".faq-item-content");
				content.style.maxHeight = content.scrollHeight + "px";
			}
		}
	}
	toggleDropdown(e) {
		if (this.options.horizontal) {
			this.toggleHorizontal(e.currentTarget);
			return;
		}
		const content = e.currentTarget.querySelector(".faq-item-content");

		if (e.currentTarget.classList.contains("submenu-is-active")) {
			e.currentTarget.classList.remove("submenu-is-active");
			content.style.maxHeight = "";
		} else {
			const containers = this.element.querySelectorAll(".faq-item");
			containers.forEach((el) => {
				el.classList.remove("submenu-is-active");
				const elc = el.querySelector(".faq-item-content");
				elc.style.maxHeight = "";
			});
			e.currentTarget.classList.add("submenu-is-active");
			content.style.maxHeight = content.scrollHeight + "px";
		}
	}
	openDropdown(e) {
    if (this.options.horizontal) {
        this.toggleHorizontal(e.currentTarget);
        return;
    }
    if (e.currentTarget.classList.contains("submenu-is-active")) return; 

    const containers = this.element.querySelectorAll(".faq-item");
    containers.forEach((el) => {
        el.classList.remove("submenu-is-active");
        el.querySelector(".faq-item-content").style.maxHeight = "";
    });

    const content = e.currentTarget.querySelector(".faq-item-content");
    e.currentTarget.classList.add("submenu-is-active");
    content.style.maxHeight = content.scrollHeight + "px";
}

	closeDropdown(e) {
			const content = e.currentTarget.querySelector(".faq-item-content");

		if (e.currentTarget.classList.contains("submenu-is-active")) {
			e.currentTarget.classList.remove("submenu-is-active");
			content.style.maxHeight = "";
		}
	}
	lockHorizontalHeight() {
		if (!this.options.horizontal) return;

		const containers = [...this.element.querySelectorAll(".faq-item")];
		const grid = containers[0].parentElement;
		const totalWidth = grid.offsetWidth;
		const count = containers.length;
		const narrowWidth = totalWidth / (count + 1);
		const heights = containers.map((el) => {
			el.classList.add("submenu-is-active");
			el.style.width = narrowWidth + "px";
			el.style.position = "absolute";
			const height = el.scrollHeight;
			el.style.width = "";
			el.style.position = "";
			el.classList.remove("submenu-is-active");
			// 2fr is twice as wide as 1fr, so we divide the height by 1.5 to get the height of the tallest item when one is active
			return Math.floor(height / 1.5);
		});

		const tallest = Math.max(...heights);
		grid.style.height = tallest + "px";
	}

	toggleHorizontal(clicked) {
		const containers = [...this.element.querySelectorAll(".faq-item")];
		const isActive = clicked.classList.contains("submenu-is-active");

		containers.forEach((el) => {
			el.classList.remove("submenu-is-active");
			const content = el.querySelector(".faq-item-content");
			content.style.opacity = "";
		});

		const grid = containers[0].parentElement;

		if (!isActive) {
			clicked.classList.add("submenu-is-active");
			const content = clicked.querySelector(".faq-item-content");

			content.style.opacity = "0";
			requestAnimationFrame(() => {
				content.style.opacity = "1";
			});

			const columns = containers.map((el) =>
				el.classList.contains("submenu-is-active") ? "2fr" : "1fr",
			);
			grid.style.gridTemplateColumns = columns.join(" ");
		} else {
			grid.style.gridTemplateColumns = containers
				.map(() => "1fr")
				.join(" ");
		}
	}
}
